module.exports = __webpack_public_path__ + "media/images/talent/case1-icon01-80e37b9eff08b351ec1bbb4e816de0ee.png";